export default __webpack_public_path__ + "static/media/PlayMoreWinMore.f305d3e4.png";